var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pos-rel vh100-min"},[_c('keep-alive',{attrs:{"include":"goods-wholesale-form"}},[_c('router-view')],1),(_vm.$store.getters.loading)?_c('Spin',{attrs:{"size":"large","fix":""}},[_c('Icon',{staticClass:"spin-icon-load",attrs:{"type":"ios-loading","size":"28"}}),_c('div',[_vm._v("Loading")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }